import { QueryFilter } from "src/app/shared/models/query-filter.model";

export class LeagueIterationsListQueryFilter extends QueryFilter {
    leagueId: string;
}

